import { useCallback } from "react";
import { EVENT_BUS_EVENTS } from "../util/useEventBus";

export const CTA_EVENT_TYPE = {
  GENERIC: "generic",
  ARTICLE_SUBSCRIPTION_BROWSE: "article-subscription-browse",
};

export const CTA_TRIGGER_ACTION = {
  FOLLOW_ICON_CLICK: "follow icon click",
  MERATIVE_ASSISTANT_VIEW: "merative assistant view",
};

export const useLaunchCTA = ({ eventBus }) => {
  const launchCTA = useCallback(
    ({ userAction, component, type = CTA_EVENT_TYPE.GENERIC }) => {
      eventBus.emit(EVENT_BUS_EVENTS.LAUNCH_CTA, null, {
        type,
        originator: {
          mfe: "browse",
          component,
          userAction,
        },
      });
    },
    [eventBus]
  );

  return { launchCTA };
};
